// extracted by mini-css-extract-plugin
export default {"panel":"DataTablePanel_panel__40G4h","error":"DataTablePanel_error__e6nXv"};